import { Data, Heading, ItemList, List, Wrapper } from './HighlightedStatsStyles';

interface HighlightedStatsProps {
  stats: {
    title: string;
    value: string;
  }[];
  dataCy?: string;
}

const HighlightedStats = ({ stats, dataCy }: HighlightedStatsProps) => (
  <Wrapper>
    <List data-cy={dataCy}>
      {stats.map((stat) => (
        <ItemList key={stat.title}>
          <Heading>{stat.title}</Heading>
          <Data>{stat.value}</Data>
        </ItemList>
      ))}
    </List>
  </Wrapper>
);

export default HighlightedStats;
